import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { RENOLOG_LOCAL_API_REQUESTS } from './constants';

// Supersedes the older `temperature-and-humidity` endpoint: same payload, with
// `pressures` alongside `temperatures` and `humidities`.
//
// A page of an assignment's readings, newest first (up to 1000). Optionally
// only those of a stretch of time, `startTime` to `endTime` (epoch ms, both
// optional; the API clamps them to the assignment's own period): the
// dashboard's last 24 hours. Without them, every reading of the assignment.
export const getTemperatureHumidityPressure = async (
  projectId,
  assignmentId,
  lastKey,
  { startTime, endTime } = {}
) => {
  const basePath = `projects/${projectId}/renolog/assignments/${assignmentId}/temperature-humidity-pressure`;
  const params = new URLSearchParams({ limit: 1000 });
  if (startTime != null) params.set('startTime', Math.floor(startTime));
  if (endTime != null) params.set('endTime', Math.ceil(endTime));
  if (lastKey) params.set('lastKey', lastKey);
  const apiPath = `${basePath}?${params.toString()}`;
  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: RENOLOG_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
